export { default as NewsCard } from './NewsCard'
export { default as NewsCardSkeleton } from './Skeleton'
